import { AnnotationOptions, BoxAnnotationOptions } from "chartjs-plugin-annotation";
import { uniqueId } from "lodash";
import {fanOnBackgroundColor} from "../../../pages/dashboard/charts/shared";
import PremierPlusTapestripDTO from "src/models/PremierPlusTapestripDTO";

export const useMachineAnnotations = (data: Array<PremierPlusTapestripDTO>): Array<AnnotationOptions> => {

    if (data == null || data?.length === 0) {
        return [];
    }
    const getChanges = () => {
        return data.filter((item, index) => {
          return index === 0 || item.isMachineOn !== data[index - 1].isMachineOn;
        });
      };
      
      const changes = getChanges();
      const annotations: AnnotationOptions[] = [];

      for (let [index, change] of changes.entries()) {
        if (change.isMachineOn) {
            annotations.push({
                type: 'box',
                xScaleID: 'x',
                id: uniqueId('statusChange-'),
                xMin: change.captureTimeUtc!,
                xMax: changes[index+1]?.captureTimeUtc ?? undefined,
                backgroundColor: fanOnBackgroundColor,
                borderWidth: 0,
                z: -2,
                drawTime: 'beforeDatasetsDraw',   
            })
        }
      }
      return annotations;

}